import { useEffect } from "react";
import styles from "./NossosDentistas.module.css";
import content from "./Quadrados.module.css"

function Main() {
    useEffect(() => {
       var WhastAppQuadrado = document.getElementById("WhastAppQuadrado");
       var mensagem = "Olá, gostaria de agendar uma consulta.";

       WhastAppQuadrado.addEventListener("click", () => {
        window.open(`https://wa.me/5512996037519?text=${mensagem}`, "_blank");
       })
    }, []);

    return (
        <main className={styles.main}>

        <section id={styles.quadradoNS}>
            <div id={styles.textoQuadrado}>
                <h1>Nossos Serviços</h1>
            </div>
            <div id={styles.maiorQuadradoNS}>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Atendimento de Urgência" className={styles.imagemUm}></iframe>
                </div>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Botox" className={styles.imagemDois}></iframe>
                </div>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Clareamento Dentário" className={styles.imagemTres}></iframe>
                </div>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Clinica Geral" className={styles.imagemQuatro}></iframe>
                </div>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Limpeza e Profilaxia" className={styles.imagemCinco}></iframe>
                </div>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Odontopediatria" className={styles.imagemSeis}></iframe>
                </div>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Protese Dentária" className={styles.imagemSete}></iframe>
                </div>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Restauração" className={styles.imagemOito}></iframe>
                </div>
                <div id={styles.miniQuadradoNS}>
                <iframe title="Tratamento de Canal" className={styles.imagemNove}></iframe>
                </div>
            </div>
                <div id={styles.agendamento}>
                    <button class={styles.botaoAgendamento} id="WhastAppQuadrado">
                        <img src="/images/Main/whatsapp.webp" alt="WhatsApp" id={styles.imagemAgendamento}></img>
                        <h1 id={styles.textoAgendamento}>Fele Conosco</h1>
                    </button>
                </div>
        </section>

        <section className={styles.quadradoIdades}>
        <div id={styles.textoQuadrado}>
                <h1>Atendimento para todas idades</h1>
            </div>
            <div className={styles.quadradoIdadesMaior}>
        <div className={styles.quadradoIdadesMenor}>
            <img src="/images/Atendimentos/Senhores.webp" alt="Senhores"></img>
            <div id={styles.quadradoTransparente}></div>
        </div>
        <div className={styles.quadradoIdadesMenor}>
            <img src="/images/Atendimentos/Adultos.webp" alt="Adultos"></img>
            <div id={styles.quadradoTransparente}></div>
        </div>
        <div className={styles.quadradoIdadesMenor}>
            <img src="/images/Atendimentos/Criancas.webp" alt="Crianças"></img>
            <div id={styles.quadradoTransparente}></div>
        </div>
        </div>
        </section>

        <section id={styles.quadradoEnd}>
            <div id={styles.miniQuadradoEnd}> 
            <div id={styles.textoQuadrado}>
                <h1>Endereço</h1>
            </div>
            <div id={styles.quadradoImagem}>
                <img src="/images/Main/fachada.webp" alt="Fachada sem dor" />
                </div>
                <p className={content.endereco}>
                    <a href="https://www.google.com/maps/dir//Pra%C3%A7a+do+Expedicion%C3%A1rio,+76+-+Centro,+S%C3%A3o+Jos%C3%A9+dos+Campos+-+SP,+12209-030/@-23.1793142,-45.8906545,999m/data=!3m1!1e3!4m9!4m8!1m0!1m5!1m1!1s0x94cc4a1933d4dab9:0x48aa4072742c7ac9!2m2!1d-45.8880796!2d-23.1793192!3e0?entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D">Praça do Expedicionário, 76 - Centro, São José dos Campos - SP, 12209-030</a></p>
                    <p className={content.endereco2}>Clique no endereço para ir para o GPS</p>
            </div>
        </section>
        <section id={styles.quadradoHorario}>
            <div id={styles.textoQuadrado}>
                <h1>Horarios</h1>
                <p>Segunda-feira a Sexta-feira : 07:00 – 18:00</p>
                <p>Sábado :	07:00 – 13:00</p>
                <p>Domingo : Fechado</p>
            </div>
        </section>
            <div className={styles.botaoWhatsApp}>
                <div className={styles.WhastAppQuadrado} id="WhastAppQuadrado">
                    <img src="/images/Main/whatsapp.webp" alt="WhatsApp"></img>
                </div>
            </div>
        </main>

    )
}

export default Main